export const FetchPTDetailsInterval = 5000;
export const PageSize = 20;
export const PageSmallSize = 6;
export const PageTinySize = 4;
export const PageDefaultSize = 12;
